<template>
  <div
    class="export-complete">
    <video autoplay muted loop>
      <source src="https://static.serato.com/visualizer/videos/swirly-purple-forms-compressed.mp4" type="video/mp4">
    </video>
    <div class="export-complete__foreground">
      <div class="export-complete__middle-container">
        <div class="export-complete__middle-section">
          <h1>Boom. Your video is ready to download</h1>
          <p class="export-complete__body-text">Video not downloading automatically? <a :href="exportStore.downloadLink" :download="exportStore.fileName">Download manually</a></p>
          <div class="export-complete__buttons">
            <big-button
              text="Continue editing"
              :is-disabled="false"
              :is-loading="false"
              type="secondary"
              @click="emits('closeOverlay')"
            />
            <big-button
              text="Make a new video"
              :is-disabled="false"
              :is-loading="false"
              type="secondary"
              @click="resetProject"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

import BigButton from '@/components/common/BigButton.vue'
import useAudioEngine from '@/composables/UseAudioEngine'
import { useProjectStore } from '@/store/project-store'
import { useApplicationStore } from '@/store/application-store'
import { useExportStore } from '@/store/export-store'
import { useStickerGalleryStore } from '@/store/gallery/sticker-store'
import { useBackgroundGalleryStore } from '@/store/gallery/background-store'
import useEffect from '@/composables/UseEffect'
import useLayers from '@/composables/UseLayers'

const projectStore = useProjectStore()
const applicationStore = useApplicationStore()
const backgroundStore = useBackgroundGalleryStore()
const stickerStore = useStickerGalleryStore()
const exportStore = useExportStore()

const { unloadAudio } = useAudioEngine()
const { removeAllEffects } = useEffect()
const { resetLayers } = useLayers()
const emits = defineEmits<{
  (event: 'closeOverlay'): void
}>()

const resetProject = () => {
  unloadAudio()
  removeAllEffects()
  resetLayers()
  backgroundStore.reset()
  stickerStore.$reset()
  applicationStore.$reset()
  projectStore.$reset()
  emits('closeOverlay')
}

</script>

<style lang="scss">
.export-complete {
  height: 100%;
  width: 100%;
  color: $white;
  font-family: $font-regular;

  >video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &__foreground {
    position: absolute;
    height: 100%;
    width: 100%;
    bottom: 0;
  }

  &__middle-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h1 {
    font-size: 44px;
  }
  p {
    font-size: 16px;
    >a {
      color: $link-blue;
      text-decoration: none;
    }
  }

  &__middle-section {
    flex-grow: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  &__body-text {
    margin-top: 26px;
  }

  &__buttons {
    margin-top: 34px;
    .big-button {
      margin: 0px 10px;
    }
  }
}
</style>
